import styled from 'styled-components'

export const Field = styled.input`
  box-shadow: ${({ isRequiredError }) => isRequiredError && '0 0 0.15rem 0.05rem red'};
  &:focus {
    outline: none;
    box-shadow: ${({ isRequiredError }) => isRequiredError && '0 0 0.3rem 0.1rem red'};
  }
  flex: 1;
  width: 100%;

  margin-left: 0.3rem;
  margin-right: 0.3rem;

  & > label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &[type='number']:after {
    content: "KG";
  }

  & > input, select {
    height: 48px;
    border: 1px solid #c7c9c7;
    box-sizing: border-box;
    border-radius: 4px;

    &[type='date']:invalid {
      color: #757575;
    }

    &:focus {
      outline: 2px solid #2962ff;
    }

    &:disabled {
      background-color: #f0f0f0;
    }
  }
   & > select {
     cursor: pointer;
   }

`

export const FieldDescription = styled(Field)`
  flex: 4;
`

export const Fieldset = styled.fieldset`
  padding: 1rem 0 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`
export const ButtonWrapper = styled.div`
  margin: 25px 10px;
`

export const ModalAlertDueDateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  gap: 1rem;
`

export const ModalAlertDueDateInfo = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  gap: 1rem;
`